import {
	ActionsTypes,
	ActionTypeToDataMapping
} from "../../batch-actions-modals/constants";
import { triggerChecklistsActions } from "api";

const prepareBatchAction = (config, shouldDuplicate, shouldArchive) => {
	return config.map(item => ({
		...item,
		should_duplicate_checklist: shouldDuplicate,
		should_archive_source_checklist: !!shouldArchive
	}));
};

export const checklistTriggerAction = ({ organizationId, type, data }) => {
	let config;

	switch (type) {
		case ActionsTypes.TRANSFER_CHECKLISTS:
			config = prepareBatchAction(data.config, false, false);
			break;

		case ActionsTypes.DUPLICATE_CHECKLISTS:
			config = prepareBatchAction(
				data.config,
				true,
				data.config.some(item => !!item.should_archive_source_checklist)
			);
			break;
		case ActionsTypes.LINK_WEEZ_TAG_TO_CHECKLISTS:
			config = data.config;
			break;
		default:
			throw new Error(`Unknown action type: ${type}`);
	}

	return triggerChecklistsActions({
		organizationId,
		data: {
			type: ActionTypeToDataMapping[type],
			config
		}
	});
};
